module.exports = __webpack_public_path__ + "img/participate_award_banner_2024.a4788101.png";